import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import TextField from '@app/components/input/TextField';
import useValidationMessage from '@app/hooks/useValidationMessage';

import { AddressFormFields } from '../Address.constants';
import messages from '../Address.messages';

export const validationRules = {
  required: true,
  pattern: /^[^\p{L}\p{C}]*$/u,
};

export const PhoneField: FC<{ namespace: string }> = ({ namespace }) => {
  const {
    formState: { errors },
    register,
  } = useFormContext();

  const { msg } = useValidationMessage(messages);

  return (
    <TextField
      {...register(`${namespace}.${AddressFormFields.Phone}`, {
        required: {
          message: msg({
            type: 'required',
            key: 'phone',
          }),
          value: validationRules.required,
        },
        pattern: {
          message: msg({
            type: 'invalid',
            key: 'phone',
          }),
          value: validationRules.pattern, // same rule from old shop for consistency
        },
      })}
      data-testid={`${namespace}-phone`}
      autoComplete="tel"
      maxLength={40}
      isValid={!errors[namespace]?.[AddressFormFields.Phone]}
      formLabel={<FormattedMessage {...messages.phone} />}
      type="tel"
    />
  );
};
